import React, { useState } from 'react'
import { CButton, CForm, CFormInput, CFormLabel, CFormSelect } from '@coreui/react';
import Swal from "sweetalert2";
import axios from 'axios';
import ReactLoading from 'react-loading';
import { bebidasFijas } from './bebidasFijas'

// Estilos de los botones para subir imágenes
let uploadLabelStyle = { display: 'inline-block', padding: '10px 15px', backgroundColor: 'rgb(118, 133, 161)', color: 'white', borderRadius: '5px', cursor: 'pointer', width: '200px', };
let previewStyle = { maxWidth: '50px', maxHeight: '50px', minWidth: '50px', minHeight: '50px', objectFit: 'cover', borderRadius: '8px', boxShadow: '0 0 10px rgba(0,0,0,0.1)', };

// Componente para subir imágenes
function FileInput({ id, value, label, onFile, preview }) {
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'center' }}>
            <input type="file" style={{ display: 'none' }} id={id} onChange={(e) => onFile(e.target.files[0])} />
            <label htmlFor={id} style={uploadLabelStyle}><i className="fa-solid fa-cloud-arrow-up"></i> {label}</label>
            {preview && <img src={preview} alt="Preview" style={previewStyle} />}
        </div>
    );
}

function ImgInput({ editImg, label, handleFile, setImg, setPreviewImg, previewImg, setEditImg, infoEdit }) {
    return (
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", flexWrap: "wrap", gap: "1vw" }}>
            <span style={{ fontWeight: "bold", fontSize: "15px", }}>Imagen</span>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", flexWrap: "wrap", gap: "2vw" }} >
                {
                    editImg ?
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", flexWrap: "wrap", gap: "2vw" }}>
                            <FileInput label={label} id="uploadImg" onFile={(file) => handleFile({ target: { files: [file] } }, setImg, setPreviewImg)} preview={previewImg} />
                            <CButton color="danger" variant='outline' onClick={() => setEditImg(false)}><i className="fa-solid fa-xmark"></i></CButton>
                        </div>
                        :
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", flexWrap: "wrap", gap: "2vw" }}>
                            <img src={`https://res.cloudinary.com/activecode/image/upload/f_auto,q_auto/bebbo/drinks/drink${infoEdit._id}.jpg?${Date.now()}`} style={{ width: '70px', height: '70px', objectFit: 'cover', borderRadius: '10px' }} />
                            <CButton color="success" variant='outline' onClick={() => setEditImg(true)}><i className="fa-solid fa-pen"></i></CButton>
                        </div>
                }
            </div>
        </div>
    )
}

function Input({ label, value, valueOG, set }) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', width: '45%' }}>
            <CFormLabel style={{ fontSize: '10px' }}>{label}</CFormLabel>
            <CFormInput
                placeholder={label}
                style={{ maxWidth: '400px' }}
                value={value}
                onChange={e => set(e.target.value)}
                onBlur={() => { if (!value.trim()) { set(valueOG); } }}
            />
        </div>
    )
}

function EditBebida({ setVisible3, infoEditOG, infoEdit, setInfoEdit, arrayContiene, setArrayContiene, arrayContieneOG, setArrayContieneOG }) {
    let [loading, setLoading] = useState(false);
    let [progress, setProgress] = useState(0); // Porcentaje de carga a cloudinary

    // En las imagenes que se van a editar hay que hace estos 3 estados por cada imagen
    let [previewImg, setPreviewImg] = useState(null);
    let [img, setImg] = useState(null);
    let [editImg, setEditImg] = useState(false);
    let folderImg = `bebbo/drinks`

    // Función para manejar las imágenes y previsualizar
    function handleFile(e, setter, setPreview) {
        let file = e.target.files[0];
        setter(file); // Actualizar el estado con el archivo seleccionado
        if (file) setPreview(URL.createObjectURL(file));
    }

    // Funciones de validación
    function validarPrecio(precio) {
        return /^[0-9]{1,}$/.test(precio); // 1 o más dígitos
    }

    function validarFormulario() {
        if (!validarPrecio(infoEdit.price)) {
            Swal.fire({
                icon: "error",
                title: "Verifica el precio",
                text: "El teléfono debe tener 10 o más dígitos.",
                confirmButtonText: "Entendido",
                confirmButtonColor: "rgb(118, 133, 161)",
            })
        }

        return !validarPrecio(infoEdit.price)

    }

    // Función para validar el tipo y tamaño de la imagen
    function validarImagen(imagen) {
        if ((imagen.type !== "image/jpeg") || imagen.size > 400000) { // si el archivo pesa mas de 400kb y es tipo diferente a .jpg
            Swal.fire({
                icon: "error",
                title: "Verifica tu imagen",
                text: "Solo se permiten imágenes tipo .jpg y máximo de 400kb.",
                footer: `Esta es de tipo .${imagen.type.split("/")[1]} y pesa ${(imagen.size / 1024).toFixed(2)}kb.`,
                confirmButtonText: "Entendido",
                confirmButtonColor: "rgb(118, 133, 161)",
            })
            return false;
        }
        return true;
    }

    // Función para subir la imagen a cloudinary
    async function subirImagenACloudinary(archivo, nombreImagen, folder, tags) {
        if (!(validarImagen(archivo))) { // si la imagen es inválida
            throw new Error("Imagen inválida");
        }

        return new Promise((resolve, reject) => {
            let img = new Image();
            img.src = URL.createObjectURL(archivo);

            img.onload = async () => {
                if (false) {
                    // if (img.width < 300 || img.height < 300) { // si la imagen mide mínimo 300x300
                    Swal.fire(`La imagen debe medir mínimo 300x300px. Esta tiene ${img.width}x${img.height}`);
                    reject();
                } else {
                    let formData = new FormData();
                    formData.append("file", archivo);
                    formData.append("upload_preset", "upload_bebbo_restaurante");
                    formData.append("user", tags);
                    formData.append("folder", folder);
                    formData.append("public_id", nombreImagen);

                    try {
                        let res = await axios.post(`${process.env.REACT_APP_BackURL}/upMedia`, formData,
                            {
                                onUploadProgress: (e) => {
                                    let percent = Math.round((e.loaded * 100) / e.total);
                                    setProgress(percent);
                                }
                            }
                        );
                        resolve(res.data.secure_url);
                    } catch (err) {
                        reject(err);
                    }
                }
            };
        });
    };

    async function handleUpdate() {

        // Validar el formulario si todos los campos son correctos
        if (validarFormulario()) return;

        try {

            setLoading(true);

            // Subir las imagenes a cloudinary
            let nuevaImg = img ? await subirImagenACloudinary(img, `drink${infoEdit._id}`, folderImg, infoEditOG._id) : null;

            // Si cambio la imagen o el logo, actualizar el objeto
            if (nuevaImg) infoEdit.img = nuevaImg;

            let cambios = {};

            // Iterar sobre las claves del objeto
            Object.keys(infoEdit).forEach((key) => { if (infoEdit[key] !== infoEditOG[key]) { cambios[key] = infoEdit[key]; } });

            if (Object.keys(cambios).length === 0 && !editImg) { // Si no hay cambios
                // console.log("No hay cambios");

                // Si no hay cambios, mostrar alerta y al hacer click en ok, cerrar el modal
                Swal.fire({
                    icon: 'info',
                    title: 'Sin cambios',
                    text: 'No hiciste ninguna modificación.',
                    confirmButtonColor: 'rgb(118, 133, 161)',
                }).then((result) => { if (result.isConfirmed) { setVisible3(false); } })

            } else {

                if (cambios.description?.length > 30) {
                    Swal.fire("La descripcion de la bebida debe tener máximo 30 caracteres");
                    return;
                }

                // console.log("Cambios detectados:", cambios);

                // Actualizar el restaurante
                let res = await axios.patch(`${process.env.REACT_APP_BackURL}/updateDrinkById?id=${infoEdit._id}`, cambios);

                if (res.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Bebida actualizada',
                        text: 'Los cambios se han guardado correctamente.',
                        confirmButtonColor: 'rgb(118, 133, 161)',
                    });
                }

                // Actualizar el item en los arrays que se reciben
                let tempArrayContiene = [...arrayContiene]; // Creamos una copia
                let indexEdit = tempArrayContiene.findIndex((item) => item._id === infoEdit._id); // Buscamos el item en el array
                if (indexEdit !== -1) { tempArrayContiene[indexEdit] = infoEdit; }
                setArrayContiene(tempArrayContiene); // Actualizamos el estado

                let tempArrayContieneOG = [...arrayContieneOG]; // Creamos una copia
                let indexEditOG = tempArrayContieneOG.findIndex((item) => item._id === infoEdit._id); // Buscamos el item en el array
                if (indexEditOG !== -1) { tempArrayContieneOG[indexEditOG] = infoEdit; }
                setArrayContieneOG(tempArrayContieneOG); // Actualizamos el estado

                setVisible3(false);
            }
        } catch (error) {
            console.error(error);
            Swal.fire({ icon: "error", title: "Oops...", text: `Lo sentimos esta acción no se pudo completar. ${error}, la imagen debe ser de tipo .jpg y máximo de 400kb`, allowEscapeKey: true })
        } finally { setLoading(false) }
    }

    return (
        <>
            <CForm>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
                    {/* <Input label="Tipo" value={infoEdit.type} valueOG={infoEditOG.type} set={type => setInfoEdit({ ...infoEdit, type })} /> */}
                    <CFormLabel style={{ fontSize: '10px' }}>Tipo de bebida</CFormLabel>
                    <CFormSelect value={infoEdit.type} style={{ maxWidth: '300px', textAlign: 'center', marginBottom: '10px' }} onChange={async (e) => { setInfoEdit({ ...infoEdit, type: e.target.value }); }}>
                        <option value="" disabled hidden>Selecciona una categoria</option>
                        {
                            bebidasFijas.map((drink) => {
                                return (
                                    <option key={drink.tipo} value={drink.tipo}>{drink.tipo}</option>
                                )
                            })
                        }
                    </CFormSelect>
                    <Input label="Bebida" value={infoEdit.name} valueOG={infoEditOG.name} set={name => setInfoEdit({ ...infoEdit, name })} />
                    <Input label="Precio" value={infoEdit.price} valueOG={infoEditOG.price} set={price => setInfoEdit({ ...infoEdit, price })} />
                    <Input label="Descripcion (máximo 30 caracteres)" value={infoEdit.description} valueOG={infoEditOG.description} set={description => setInfoEdit({ ...infoEdit, description })} />
                    {/* <Input label="Sabor" value={infoEdit.flavor} valueOG={infoEditOG.flavor} set={flavor => setInfoEdit({ ...infoEdit, flavor })} /> */}
                </div>

                <br />

                {/* Imagen principal o banner */}
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", gap: "2vw" }}>
                    <ImgInput editImg={editImg} label="Imagen de bebida" handleFile={handleFile} setImg={setImg} setPreviewImg={setPreviewImg} previewImg={previewImg} setEditImg={setEditImg} infoEdit={infoEdit} />
                </div>

                <span style={{ fontWeight: "bold", fontSize: "15px", display: "flex", justifyContent: "center", marginTop: "10px" }}>La imágenes deben ser tipo .jpg y máximo 400kb</span>

            </CForm>

            <br />

            {loading ? (
                <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', marginTop: '10px' }}>
                    <ReactLoading type="spin" color="cornflowerblue" height={'3vw'} width={'3vw'} />
                    <p style={{ fontSize: '2vw', color: 'cornflowerblue' }}>{progress}%</p>
                </div>
            ) : (
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <CButton color="danger" onClick={() => setVisible3(false)}>Cancelar</CButton>
                    <CButton color="success" onClick={handleUpdate}>Actualizar</CButton>
                </div>
            )}
        </>
    )
}

export default EditBebida